import { render, staticRenderFns } from "./TodoListDetails.vue?vue&type=template&id=3cf9e7c3&"
import script from "./TodoListDetails.vue?vue&type=script&lang=js&"
export * from "./TodoListDetails.vue?vue&type=script&lang=js&"
import style0 from "./TodoListDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports